import { render, staticRenderFns } from "./SerialNumberManually.vue?vue&type=template&id=21ce1398&scoped=true"
import script from "./SerialNumberManually.vue?vue&type=script&lang=js"
export * from "./SerialNumberManually.vue?vue&type=script&lang=js"
import style0 from "./SerialNumberManually.vue?vue&type=style&index=0&id=21ce1398&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ce1398",
  null
  
)

export default component.exports